import { createRouter, createWebHashHistory } from '@ionic/vue-router';
import GymTabs from '@/WiseCore/components/GymTabs.vue'

// ModeSelector for demo mode 
let defaultPath = {
  path: '/',
  redirect: '/gym/front'
}

const routes = [
  defaultPath,
  {
    path: '/gym/',
    component: GymTabs,
    children: [
      {
        path: '',
        redirect: '/gym/front'
      },
      {
      path: 'front',
      component: () => import('@/WiseGym/views/GymFront.vue')
      },
      {
        path: 'today',
        component: () => import('@/views/WiseTodayTab.vue')
      },
      {
        path: 'today/article/:id',
        component: () => import('@/views/WiseArticle.vue'),
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router